import { InjectionToken } from '@angular/core'

type FloAdBlockPingUrl = string

export const AD_BLOCK_PING_URL = new InjectionToken<FloAdBlockPingUrl>('fs.ab.ping-url')
